import { render } from "./ContentComponentSelector.vue?vue&type=template&id=1e952768&ts=true"
import script from "./contentComponentSelector?vue&type=script&lang=ts"
export * from "./contentComponentSelector?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__